import { render, staticRenderFns } from "./tagMatching.vue?vue&type=template&id=443665fc&scoped=true&"
import script from "./tagMatching.vue?vue&type=script&lang=js&"
export * from "./tagMatching.vue?vue&type=script&lang=js&"
import style0 from "./tagMatching.vue?vue&type=style&index=0&id=443665fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443665fc",
  null
  
)

export default component.exports